module.exports = __webpack_public_path__ + "static/media/Locally-Owned.40e6f290.svg";